import { createContext } from 'react';
import { DEFAULT_EVALUATION_CONTEXT } from './constants/defaultContext';
export const EvaluationContext = createContext(DEFAULT_EVALUATION_CONTEXT);
